const scrollToElement = (id: string) => {
  const input = document.getElementById(id);
  if (input) {
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};

export default scrollToElement;
